export default "__VITE_ASSET__DEUoEtQt__"